<footer>
    <div class="footer-wrap">
        <div class="text">
            <span> <strong>(주)아이로브</strong> 경기도 성남시 수정구 복정로 115 대림빌딩 3층,
                031-698-4115
            </span>
            <p>copyright ⓒ 2020 AIROV CO.,LTD. ALL RIGHTS RESERVED.</p>
        </div>
        <div class="familysite">
            <select>
                <option>Family Site</option>
                <option>Billi AI</option>
                <option>Carrotly</option>
            </select>
        </div>
    </div>
</footer>